import { BUSCAR_CAIXA_ABERTO } from '../../actions/types'

export default function reducerCaixaAberto (state = null, action) {
  switch (action.type) {
    case BUSCAR_CAIXA_ABERTO: {
      return action.payload.data;
    }

    default: {
      return state
    }
  }
}
